export const NETWORK_COLOR = { connected: 'success', reconnecting: 'warning', disconnected: 'error' };
export type BadgeColor = 'success' | 'warning' | 'error';

export const DRAWER_WIDTH = 200;
export const MAX_DASHBOARD_NAME_LENGTH = 18;
export const AUTO_CLOSE_DELAY = 5000;
export const AUTO_CLOSE_START_DELAY = 1000;

export const SUPPORT_NUMBERS = [
  { countryCode: 'UK', phoneNumber: '+44 208 154 9880' },
  { countryCode: 'SG', phoneNumber: '+65 6859 2784' },
];
